import {
	Box,
	Center,
	Container,
	Grid,
	GridItem,
	Heading,
	Icon,
	Text,
	Button,
} from '@chakra-ui/react'
import { useSelector } from 'react-redux'
import { FaMapMarkerAlt, FaCheck, FaChartLine } from 'react-icons/fa'
import { FiPlus } from 'react-icons/fi'
import HomeSearchForm from '../components/HomeSearchForm'
import TopBusinessInLocation from '../components/TopBusinessInLocation'
import TopLocations from '../components/TopLocations'
import { Link } from 'react-router-dom'

const AppHome = () => {
	const { user } = useSelector((state) => state.auth)
	return (
		<>
			<Box
				bgImg={'/hero_bg.jpg'}
				py={['40px', '60px', '80px', '100px']}
				bgRepeat={'no-repeat'}
				bgSize={'cover'}
				bgPos={'center'}
			>
				<Container maxW={'container.xl'}>
					<Center justifyContent={'center'}>
						<Box maxW={'800px'} w="100%">
							<Box
								p={6}
								rounded={10}
								pos={'relative'}
								_before={{
									content: "''",
									pos: 'absolute',
									top: 0,
									right: 0,
									bottom: 0,
									left: 0,
									bg: 'whiteAlpha.900',
									zIndex: 0,
									rounded: 10,
									overflow: 'hidden',
									backdropFilter: 'saturate(180%) blur(20px)',
								}}
							>
								<Box pos={'relative'} zIndex={'10'}>
									<Box
										textAlign={['center', 'center', 'center', 'center']}
										mb={9}
									>
										<Heading
											lineHeight={1.35}
											fontSize={['1.5rem', '1.5rem', '1.8rem', '2.2rem']}
											as={'h1'}
										>
											Discover Options Near You Or Your Vacation Destination!
										</Heading>
										<Text mt={4}>
											Find great rental businesses near you in USA and Canada!
										</Text>
									</Box>
									<HomeSearchForm />
								</Box>
							</Box>
						</Box>
					</Center>
				</Container>
			</Box>

			{/* Top Business in Location */}
			<TopBusinessInLocation />

			{/* Application Feature */}
			<Box>
				<Container maxW={'container.xl'}>
					<Box
						rounded={10}
						color={'brand.50'}
						bg={'brand.500'}
						py={'60px'}
						px={8}
					>
						<Box mb={'50px'} textAlign={['center', 'center', 'left', 'left']}>
							<Heading
								color={'white'}
								fontSize={'1.75rem'}
								textAlign={'center'}
								as={'h3'}
							>
								Add Your Business to
							</Heading>
							{/* <Text mt={'3'}>
								Lorem ipsum is a placeholder text commonly used
							</Text> */}
						</Box>

						<Grid
							templateColumns={[
								'repeat(1, 1fr)',
								'repeat(1, 1fr)',
								'repeat(2, 1fr)',
								'repeat(3, 1fr)',
							]}
							gap={8}
						>
							<GridItem>
								<Box textAlign={['center', 'center', 'left', 'left']}>
									<Icon
										fontSize={'2.5rem'}
										color={'brand.200'}
										as={FaMapMarkerAlt}
									/>
									<Text size={'1.35rem'} my={3} fontWeight={500} color="white">
										Get Discovered
									</Text>
									<Text>Show up on our searches and other search engines</Text>
								</Box>
							</GridItem>

							<GridItem>
								<Box textAlign={['center', 'center', 'left', 'left']}>
									<Icon fontSize={'2.5rem'} color={'brand.200'} as={FaCheck} />
									<Text size={'1.35rem'} my={3} fontWeight={500} color="white">
										Gain Reliability
									</Text>
									<Text>
										Become reliable business owners with the easy verification
										process
									</Text>
								</Box>
							</GridItem>

							<GridItem>
								<Box textAlign={['center', 'center', 'left', 'left']}>
									<Icon
										fontSize={'2.5rem'}
										color={'brand.200'}
										as={FaChartLine}
									/>
									<Text size={'1.35rem'} my={3} fontWeight={500} color="white">
										Showcase Products
									</Text>
									<Text>
										Showcase your best products and services to attract probable
										buyers.
									</Text>
								</Box>
							</GridItem>
						</Grid>

						{!user && (
							<Box textAlign={'center'} mt={10}>
								<Button
									as={Link}
									to="/business"
									variant={'outline'}
									_hover={{ bg: 'transparent' }}
									_active={{ bg: 'transparent' }}
									_focus={{ bg: 'transparent' }}
									leftIcon={<FiPlus />}
								>
									Add Your Business
								</Button>
							</Box>
						)}
					</Box>
				</Container>
			</Box>

			{/* Worldwide Top Locations */}
			<TopLocations />
		</>
	)
}

export default AppHome
